import React from "react";
import { useCasinoStyles } from "./useCasinoStyles";


export default function TeenpattiOneDay() {
 useCasinoStyles();

  return (
    <>
      <div data-v-61537a09="">
  <div data-v-61537a09="" className="detail-page-container">
    <div className="center-main-container">
      <div className="center-content">
        <div className="casino-container">
          <div className="casino-table vcasino vteen1day">
            <div className="progress mobile-timer">
              <div
                className="progress-bar bg-success"
                style={{ width: "93.33%" }}
              />
            </div>{" "}
            <div className="casino-video">
              <div className="casino-video-title">
                <span className="casino-name">V-Teenpatti 1-day</span>{" "}
                <div className="casino-video-rid">
                  Round ID: 301260922000607
                </div>
              </div>{" "}
              <div className="video-box-container">
                <div className="video-box" />
              </div>{" "}
              <div className="vcasino-cards">
                <div className="player-card playera-card">
                  {/**/} <div className="w-100 playera mb-2">Player A</div>{" "}
                  <span data-v-79776e43="">
                    <img
                      data-v-79776e43=""
                      src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/ACC.png"
                    />
                  </span>{" "}
                  <span data-v-79776e43="">
                    <img
                      data-v-79776e43=""
                      src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/1.png"
                    />
                  </span>{" "}
                  <span data-v-79776e43="">
                    <img
                      data-v-79776e43=""
                      src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/1.png"
                    />
                  </span>
                </div>{" "}
                <div className="player-card playerb-card">
                  {/**/} <div className="w-100 playerb mb-2">Player B</div>{" "}
                  <span data-v-79776e43="">
                    <img
                      data-v-79776e43=""
                      src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/1.png"
                    />
                  </span>{" "}
                  <span data-v-79776e43="">
                    <img
                      data-v-79776e43=""
                      src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/1.png"
                    />
                  </span>{" "}
                  <span data-v-79776e43="">
                    <img
                      data-v-79776e43=""
                      src="https://versionobj.ecoassetsservice.com/v106/static/admin/img/cards/6SS.png"
                    />
                  </span>
                </div>
              </div>{" "}
              <div className="casino-video-right-icons">
                <div title="Home" className="casino-video-home-icon">
                  <a
                    href="/admin/vcasino/list"
                    className=""
                    style={{ color: "var(--text-highlight)" }}
                  >
                    <i className="fas fa-home" />
                  </a>
                </div>{" "}
                <div title="Rules" className="casino-video-rules-icon">
                  <i className="fas fa-info-circle" />
                </div>
              </div>{" "}
              <div>
                {/**/} {/**/}
              </div>
            </div>{" "}
            <div className="casino-detail">
              <div className="main-odds">
                <div className="odds-title">
                  <div className="playera">Player A</div> <div>&nbsp;</div>{" "}
                  <div className="playerb">Player B</div>
                </div>{" "}
                <div className="odds-section">
                  <div className="odds-box">
                    <div className="casino-bl-box">
                      <div className="back casino-bl-box-item">
                        <span className="casino-box-odd">1.36</span>
                      </div>{" "}
                      <div className="lay casino-bl-box-item">
                        <span className="casino-box-odd">1.39</span>
                      </div>
                    </div>{" "}
                    <div className="w-100 odds-book text-center book-red">
                      0
                    </div>
                  </div>{" "}
                  <div className="odds-box pt-2">
                    <div className="vminmax">
                      <b>Main</b>{" "}
                      <div className="d-inline-block ml-2">
                        <i
                          data-toggle="collapse"
                          data-target="#range7"
                          aria-expanded="false"
                          className="fas fa-info-circle collapsed"
                        />{" "}
                        <div id="range7" className="icon-range collapse">
                          R:<span>25</span>-<span>25K</span>
                        </div>
                      </div>
                    </div>
                  </div>{" "}
                  <div className="odds-box">
                    <div className="casino-bl-box">
                      <div className="back casino-bl-box-item suspended">
                        <span className="casino-box-odd">0</span>
                      </div>{" "}
                      <div className="lay casino-bl-box-item suspended">
                        <span className="casino-box-odd">0</span>
                      </div>
                    </div>{" "}
                    <div className="w-100 odds-book text-center book-red">
                      0
                    </div>
                  </div>
                </div>{" "}
                <div className="odds-section">
                  <div className="odds-box">
                    <div className="casino-bl-box">
                      <div className="back casino-bl-box-item suspended">
                        <span className="casino-box-odd">0</span>
                      </div>{" "}
                      <div className="lay casino-bl-box-item suspended">
                        <span className="casino-box-odd">0</span>
                      </div>
                    </div>{" "}
                    <div className="w-100 odds-book text-center book-red">
                      0
                    </div>
                  </div>{" "}
                  <div className="odds-box pt-2">
                    <div className="vminmax">
                      <b>Consecutive</b>{" "}
                      <div className="d-inline-block ml-2">
                        <i
                          data-toggle="collapse"
                          data-target="#range12"
                          aria-expanded="false"
                          className="fas fa-info-circle collapsed"
                        />{" "}
                        <div id="range12" className="icon-range collapse">
                          R:<span>25</span>-<span>10K</span>
                        </div>
                      </div>
                    </div>
                  </div>{" "}
                  <div className="odds-box">
                    <div className="casino-bl-box">
                      <div className="back casino-bl-box-item suspended">
                        <span className="casino-box-odd">0</span>
                      </div>{" "}
                      <div className="lay casino-bl-box-item suspended">
                        <span className="casino-box-odd">0</span>
                      </div>
                    </div>{" "}
                    <div className="w-100 odds-book text-center book-red">
                      0
                    </div>
                  </div>
                </div>
              </div>{" "}
              <div className="others-odds">
                <div className="odds-section">
                  <div className="odds-box w-100">
                    <div className="d-inline-block pr">
                      <b>ODD</b>{" "}
                      <div className="d-inline-block ml-2">
                        <i
                          data-toggle="collapse"
                          data-target="#range13"
                          className="fas fa-info-circle"
                        />{" "}
                        <div id="range13" className="collapse icon-range">
                          R:<span>25</span>-<span>10K</span>
                        </div>
                      </div>
                    </div>
                  </div>{" "}
                  <div className="odds-box">
                    <div className="casino-bl-box">
                      <div className="back casino-bl-box-item suspended">
                        <span className="casino-box-odd">0</span>
                      </div>{" "}
                      <div className="casino-book book-red">0</div>
                      {/**/}
                    </div>
                  </div>
                  <div className="odds-box">
                    <div className="casino-bl-box">
                      <div className="back casino-bl-box-item suspended">
                        <span className="casino-box-odd">0</span>
                      </div>{" "}
                      <div className="casino-book book-red">0</div>
                      {/**/}
                    </div>
                  </div>
                  <div className="odds-box">
                    <div className="casino-bl-box">
                      <div className="back casino-bl-box-item">
                        <span className="casino-box-odd">1.83</span>
                      </div>{" "}
                      <div className="casino-book book-red">0</div>
                      {/**/}
                    </div>
                  </div>
                  <div className="odds-box">
                    <div className="casino-bl-box">
                      <div className="back casino-bl-box-item suspended">
                        <span className="casino-box-odd">0</span>
                      </div>{" "}
                      <div className="casino-book book-red">0</div>
                      {/**/}
                    </div>
                  </div>
                  <div className="odds-box">
                    <div className="casino-bl-box">
                      <div className="back casino-bl-box-item suspended">
                        <span className="casino-box-odd">0</span>
                      </div>{" "}
                      <div className="casino-book book-red">0</div>
                      {/**/}
                    </div>
                  </div>
                  <div className="odds-box">
                    <div className="casino-bl-box">
                      <div className="back casino-bl-box-item suspended">
                        <span className="casino-box-odd">0</span>
                      </div>{" "}
                      <div className="casino-book book-red">0</div>
                      {/**/}
                    </div>
                  </div>
                </div>{" "}
                <div className="odds-section">
                  <div className="odds-box w-100">
                    <div className="d-inline-block pr">
                      <b>EVEN</b>{" "}
                      <div className="d-inline-block ml-2">
                        <i
                          data-toggle="collapse"
                          data-target="#range14"
                          className="fas fa-info-circle"
                        />{" "}
                        <div id="range14" className="collapse icon-range">
                          R:<span>25</span>-<span>10K</span>
                        </div>
                      </div>
                    </div>
                  </div>{" "}
                  <div className="odds-box">
                    <div className="casino-bl-box">
                      {/**/}
                      <div className="back casino-bl-box-item suspended">
                        <span className="casino-box-odd">0</span>
                      </div>{" "}
                      <div className="casino-book book-red">0</div>
                    </div>
                  </div>
                  <div className="odds-box">
                    <div className="casino-bl-box">
                      {/**/}
                      <div className="back casino-bl-box-item suspended">
                        <span className="casino-box-odd">0</span>
                      </div>{" "}
                      <div className="casino-book book-red">0</div>
                    </div>
                  </div>
                  <div className="odds-box">
                    <div className="casino-bl-box">
                      {/**/}
                      <div className="back casino-bl-box-item">
                        <span className="casino-box-odd">2.14</span>
                      </div>{" "}
                      <div className="casino-book book-red">0</div>
                    </div>
                  </div>
                  <div className="odds-box">
                    <div className="casino-bl-box">
                      {/**/}
                      <div className="back casino-bl-box-item suspended">
                        <span className="casino-box-odd">0</span>
                      </div>{" "}
                      <div className="casino-book book-red">0</div>
                    </div>
                  </div>
                  <div className="odds-box">
                    <div className="casino-bl-box">
                      {/**/}
                      <div className="back casino-bl-box-item suspended">
                        <span className="casino-box-odd">0</span>
                      </div>{" "}
                      <div className="casino-book book-red">0</div>
                    </div>
                  </div>
                  <div className="odds-box">
                    <div className="casino-bl-box">
                      {/**/}
                      <div className="back casino-bl-box-item suspended">
                        <span className="casino-box-odd">0</span>
                      </div>{" "}
                      <div className="casino-book book-red">0</div>
                    </div>
                  </div>
                </div>
              </div>{" "}
              {/**/}{" "}
              <div className="casino-video-last-results">
                <span className="resulta">
                  A {/**/} {/**/}
                </span>
                <span className="resulta">
                  A {/**/} {/**/}
                </span>
                <span className="resultb">
                  {/**/} B {/**/}
                </span>
                <span className="resulta">
                  A {/**/} {/**/}
                </span>
                <span className="resultb">
                  {/**/} B {/**/}
                </span>
                <span className="resultb">
                  {/**/} B {/**/}
                </span>
                <span className="resultb">
                  {/**/} B {/**/}
                </span>
                <span className="resultb">
                  {/**/} B {/**/}
                </span>
                <span className="resulta">
                  A {/**/} {/**/}
                </span>
                <span className="resultb">
                  {/**/} B {/**/}
                </span>{" "}
                {/**/} {/**/}
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
      <div className="right-sidebar">
        <div className="right-sidebar">
          <div data-simplebar-auto-hide="true" data-simplebar="init">
            <div className="simplebar-wrapper" style={{ margin: 0 }}>
              <div className="simplebar-height-auto-observer-wrapper">
                <div className="simplebar-height-auto-observer" />
              </div>{" "}
              <div className="simplebar-mask">
                <div
                  className="simplebar-offset"
                  style={{ right: 0, bottom: 0 }}
                >
                  <div
                    className="simplebar-content-wrapper"
                    tabIndex={0}
                    role="region"
                    aria-label="scrollable content"
                    style={{ height: "auto", overflow: "hidden" }}
                  >
                    <div className="simplebar-content" style={{ padding: 0 }}>
                      <div className="casino-right-sidebar">
                        <div className="card m-b-10 my-bet">
                          <div className="card-header">
                            <h6 className="card-title float-left">My Bets</h6>{" "}
                            <a
                              href="javascript:void(0)"
                              className="btn btn-back float-right"
                            >
                              View More
                            </a>
                          </div>{" "}
                          <div className="card-body1">
                            <div className="tab-content">
                              <div id="matched-bet" className="tab-pane active">
                                <div className="table-responsive1">
                                  <table className="table coupon-table table-striped mb-0">
                                    <thead>
                                      <tr>
                                        <th style={{ minWidth: 90 }}>
                                          UserName
                                        </th>{" "}
                                        <th
                                          className="text-right"
                                          style={{ minWidth: 50 }}
                                        >
                                          Rate
                                        </th>{" "}
                                        <th
                                          className="text-right"
                                          style={{ minWidth: 70 }}
                                        >
                                          Amount
                                        </th>
                                      </tr>
                                    </thead>{" "}
                                    <tbody>
                                      <tr>
                                        <td colSpan={4} className="text-center">
                                          No records found
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>{" "}
                        {/**/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>{" "}
              <div
                className="simplebar-placeholder"
                style={{ width: "auto", height: 100 }}
              />
            </div>{" "}
            <div
              className="simplebar-track simplebar-horizontal"
              style={{ visibility: "hidden" }}
            >
              <div
                className="simplebar-scrollbar"
                style={{ width: 0, display: "none" }}
              />
            </div>{" "}
            <div
              className="simplebar-track simplebar-vertical"
              style={{ visibility: "hidden" }}
            >
              <div
                className="simplebar-scrollbar"
                style={{ height: 0, display: "none" }}
              />
            </div>
          </div>{" "}
          {/**/} {/**/}
        </div>
      </div>
    </div>
  </div>
</div>

    </>
  );
}
